export const ACCOUNT_FLYOUT_MODAL = 'account-flyout-modal';
